export const KeyConstant = {
  ALTERNATIVE_ADDRESS: 'Vereda',
  ALTERNATIVE_ADDRESS_CODE: 'VE',
  SOCIAL_VIOLENCE: 'Desplazamiento forzado',
  SOCIAL_VIOLENCE_KEY: 'VIC_04',
  OPTION_A: 'Si',
  OPTION_B: 'No',
  ANOTHER_OPTION: 'Otra',
  SCHOOL_TYPE: 'NNAJ',
  YES: 'Si',
  NO: 'No'
};
